import React, { useCallback } from 'react';
import { useField } from 'formik';
import PropTypes from 'prop-types';

import { NO_REPORT, NURSING_HOME, RECURRING_EXAMINATION } from 'store/patients';
import { SUB_ORGANIZATION, NO_PATIENT_REPORTS } from 'store/organizations';
import Checkbox from 'components/CheckboxNew';
import { WarnMessage } from '../styles';

const PatientReport = ({ readMode }) => {
  const [{ value: noReport }, , { setValue: setNoReport }] = useField(NO_REPORT);
  const [{ value: recurringExamination }, , { setValue: setRecurringExamination }] = useField(RECURRING_EXAMINATION);

  const [{ value: noPatientReports }] = useField(`${NURSING_HOME}.${SUB_ORGANIZATION}.${NO_PATIENT_REPORTS}`);

  const updateNoReport = useCallback(() => {
    if (!readMode) setNoReport(!noReport);
  }, [readMode, setNoReport, noReport]);
  const updateRecurringExamination = useCallback(() => {
    if (!readMode) setRecurringExamination(!recurringExamination);
  }, [readMode, setRecurringExamination, recurringExamination]);

  return (
    <>
      <Checkbox label="Keinen Bericht an Patient senden" selected={noReport} onClick={updateNoReport} readMode={readMode} />
      {Boolean(noPatientReports) && (
        <WarnMessage type="error">
          Hinweis: Es wird kein Bericht an den Patienten gesendet, da dies im Pflegeheim entsprechend hinterlegt ist.
        </WarnMessage>
      )}
      <Checkbox
        label="Wiederkehrende Kontrolle gewünscht"
        selected={recurringExamination}
        onClick={updateRecurringExamination}
        readMode={readMode}
      />
    </>
  );
};

PatientReport.propTypes = {
  readMode: PropTypes.bool.isRequired,
};

export default PatientReport;
